<h1 mat-dialog-title>Delete {{ data.isRepeating ? 'repeating' : 'scheduled' }} {{ data.meetingLanguage.item }}</h1>
<mat-dialog-content>
  @if (!data.isRepeating) {
    <div>
      <p>Are you sure you want to delete this scheduled {{ data.meetingLanguage.item }} ?</p>
    </div>
  }

  @if (data.isRepeating) {
    <div>
      <p>
        This {{ data.meetingLanguage.item }} is scheduled to repeat {{ data.cadence }}. Do you want to delete only this
        scheduled {{ data.meetingLanguage.item }} or all scheduled {{ data.meetingLanguage.items }}?
      </p>
      <terra-radio-group [(ngModel)]="deleteOption">
        <terra-radio-button [value]="DeleteOption.one" data-cy="delete-schedule_radio-btn-one"
          >Delete only this scheduled {{ data.meetingLanguage.item }}</terra-radio-button
        ><br />
        <terra-radio-button [value]="DeleteOption.all" data-cy="delete-schedule_radio-btn-all"
          >Delete all repeating scheduled {{ data.meetingLanguage.items }}</terra-radio-button
        >
      </terra-radio-group>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <ninety-button stroked mat-dialog-close class="right-space-10">Cancel</ninety-button>
  <ninety-button
    filled
    primary
    [mat-dialog-close]="true"
    (click)="onDelete()"
    data-cy="delete-schedule-actions_delete-btn"
    >Delete</ninety-button
  >
</mat-dialog-actions>
